import { motion } from "framer-motion";
import SectionTitle from "../ui/SectionTitle";

import {
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaReact,
  FaNodeJs,
  FaWordpress,
  FaGithub,
  // FaGitAlt,
  FaPhp,
} from "react-icons/fa";

import {
  SiNextdotjs,
  SiTailwindcss,
  SiBootstrap,
  SiMongodb,
  SiMysql,
  SiFramer,
  SiRedux,
  SiWoocommerce,
} from "react-icons/si";

const skills = [
  {
    icon: <FaHtml5 />,
    title: "HTML5",
    color: "text-orange-500",
    desc: "Semantic and accessible markup."
  },
  {
    icon: <FaCss3Alt />,
    title: "CSS3",
    color: "text-sky-500",
    desc: "Modern layouts and animations."
  },
  {
    icon: <FaJs />,
    title: "JavaScript",
    color: "text-yellow-400",
    desc: "ES6+, APIs and advanced concepts."
  },
  {
    icon: <FaReact />,
    title: "React",
    color: "text-cyan-400",
    desc: "Component driven applications."
  },
  {
    icon: <SiNextdotjs />,
    title: "Next.js",
    color: "text-white",
    desc: "SSR, SSG and SEO optimized apps."
  },
  {
    icon: <SiTailwindcss />,
    title: "Tailwind CSS",
    color: "text-cyan-500",
    desc: "Utility-first responsive UI."
  },
  {
    icon: <FaWordpress />,
    title: "WordPress",
    color: "text-blue-500",
    desc: "Custom themes & plugins."
  },
  {
    icon: <SiWoocommerce />,
    title: "WooCommerce",
    color: "text-violet-400",
    desc: "Custom ecommerce solutions."
  },
  {
    icon: <FaPhp />,
    title: "PHP",
    color: "text-indigo-400",
    desc: "Backend & WordPress development."
  },
  {
    icon: <FaNodeJs />,
    title: "Node.js",
    color: "text-green-500",
    desc: "REST APIs and server apps."
  },
  {
    icon: <SiMongodb />,
    title: "MongoDB",
    color: "text-green-400",
    desc: "NoSQL database."
  },
  {
    icon: <SiMysql />,
    title: "MySQL",
    color: "text-blue-400",
    desc: "Relational databases."
  },
  {
    icon: <SiRedux />,
    title: "Redux",
    color: "text-violet-500",
    desc: "Global state management."
  },
  {
    icon: <SiBootstrap />,
    title: "Bootstrap",
    color: "text-purple-500",
    desc: "Rapid responsive layouts."
  },
  {
    icon: <SiFramer />,
    title: "Framer Motion",
    color: "text-pink-500",
    desc: "Modern UI animations."
  },
  {
    icon: <FaGithub />,
    title: "GitHub",
    color: "text-white",
    desc: "Version control."
  },
];

export default function Skills() {
  return (
    <section
      id="skills"
      className="section bg-[#050816] relative overflow-hidden"
    >
      <div className="absolute right-0 top-40 h-96 w-96 rounded-full bg-blue-500/10 blur-[130px]" />

      <div className="container">

        <SectionTitle
          subtitle="Technical Skills"
          title="Technologies I Work With"
        />

        <div className="max-w-3xl mb-16">

          <p className="text-slate-400 leading-8 text-lg">

            My expertise spans frontend development,
            headless WordPress architecture, performance
            optimization and scalable web applications.
            I enjoy building clean interfaces that combine
            beautiful design with maintainable code.

          </p>

        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">

          {skills.map((skill, index) => (

            <motion.div
              key={skill.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: .45,
                delay: index * .05,
              }}
              viewport={{ once: true }}
              className="group relative overflow-hidden rounded-3xl border border-white/10 bg-white/5 p-8 backdrop-blur-lg transition-all duration-500 hover:-translate-y-3 hover:border-blue-500 hover:bg-white/[0.08]"
            >

              <div className="absolute right-0 top-0 h-32 w-32 rounded-full bg-blue-500/10 blur-3xl opacity-0 transition duration-500 group-hover:opacity-100" />

              <div className={`text-5xl ${skill.color}`}>

                {skill.icon}

              </div>

              <h3 className="mt-8 text-2xl font-bold">

                {skill.title}

              </h3>

              <p className="mt-5 leading-8 text-slate-400">

                {skill.desc}

              </p>

            </motion.div>

          ))}

        </div>

        {/* Bottom Statistics */}

        <div className="mt-24 grid gap-8 md:grid-cols-4">

          {[
            ["10+", "Years Experience"],
            ["1000+", "Projects Delivered"],
            ["200+", "Happy Clients"],
            ["25+", "Countries Served"],
          ].map((item) => (

            <div
              key={item[1]}
              className="rounded-3xl border border-white/10 bg-gradient-to-b from-white/5 to-white/[0.02] p-10 text-center"
            >

              <h3 className="text-5xl font-black text-blue-500">

                {item[0]}

              </h3>

              <p className="mt-3 text-slate-400">

                {item[1]}

              </p>

            </div>

          ))}

        </div>

      </div>
    </section>
  );
}